import { create } from 'zustand';

interface PortalTenantScopeStore {
  tenantSlug: string | null;
  tenantId: string | null;
  tenantName: string | null;

  setScope: (slug: string, tenantId: string, tenantName: string) => void;
  clearScope: () => void;
}

export const usePortalTenantScopeStore = create<PortalTenantScopeStore>((set) => ({
  tenantSlug: null,
  tenantId: null,
  tenantName: null,

  setScope: (slug, tenantId, tenantName) => set({ tenantSlug: slug, tenantId, tenantName }),
  clearScope: () => set({ tenantSlug: null, tenantId: null, tenantName: null }),
}));
